import { useEffect } from 'react';

/**
 * Custom hook to manage scrolling to the end of a message list
 * and focusing an input element.
 * 
 * @param {React.RefObject} endOfMessagesRef - Ref attached to the element marking the end of the messages.
 * @param {React.RefObject} inputRef - Ref attached to the input element to focus.
 * @param {Array} messages - The array of messages; scrolling happens when this changes.
 */
export const useScrollAndFocus = (endOfMessagesRef, inputRef, messages) => {
  // Effect to scroll to the bottom when messages change
  useEffect(() => {
    if (messages.length > 0) {
      endOfMessagesRef.current?.scrollIntoView({ behavior: "smooth" });
    }
  }, [messages, endOfMessagesRef]); // Add endOfMessagesRef to dependency array

  // Effect to focus the input shortly after mount
  useEffect(() => {
    const timer = setTimeout(() => {
      inputRef.current?.focus();
    }, 100); // Small delay can help ensure the element is ready
    return () => clearTimeout(timer); // Cleanup timer on unmount
  }, [inputRef]); // Add inputRef to dependency array
};